// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2VFSk","inputWrap":"Table_inputWrap__38hwX","col":"Table_col__qKQzq","bmiTooltip":"Table_bmiTooltip__3BX2Z"};